export default __webpack_public_path__ + "static/media/640_dummy2016-zahnarzt01-mobile-de.cb30b22d.png";